import axios from 'axios'

export const auth = {
    state:{
        token: localStorage.getItem("token") || '',
        logindetails: {},
        isUserLogged:false,
        isAdminLogged: false
    },
    mutations:{
      Login(state,token){
        state.token = token
        state.isUserLogged = true
      },
      LoginDetails(state, data){
        state.logindetails = data
        state.isAdminLogged = data.data.isAdmin
      },
      Logout(state){
        state.isUserLogged = false
      }
        
    },
    actions:{
      Login: ({commit}, payload) => {
        return new Promise((resolve, reject)=>{
          axios.post("/user_auth",payload)
          .then(({data, status})=>{
            if(status === 200){
              const token = data.data.tokens
              localStorage.setItem("token", token)
              axios.defaults.headers.common['Authorization'] = token
              commit('Login', token)
              commit('LoginDetails', data)
              resolve(data);
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      LoginGoogle: ({commit}, payload) => {
        return new Promise((resolve, reject)=>{
          axios.post("/google/login", payload)
          .then(({data, status})=>{
            if(status === 200){
              const token = data.data.tokens
              localStorage.setItem("token", token)
              axios.defaults.headers.common['Authorization'] = token
              commit('Login', token)
              commit('LoginDetails', data)
              resolve(data);
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      GoogleLogin: ({commit}, payload) => {
        return new Promise((resolve, reject)=>{
          axios.post("/auth/google", payload)
          .then(({data, status})=>{
            if(status === 200){
              const token = data.token
              localStorage.setItem("token", token)
              axios.defaults.headers.common['Authorization'] = token
              commit('Login', token)
              commit('LoginDetails', data)
              resolve(data);
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      Register: ({commit}, payload) => {
        return new Promise((resolve, reject)=>{
          axios.post("/users", payload)
          .then(({data, status})=>{
            if(status === 200){
              resolve(data);
              commit()
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      ChangePassword: ({commit}, payload) => {
        return new Promise((resolve, reject)=>{
          axios.post("/users/resetpassword",payload)
          .then(({data, status})=>{
            if(status === 200){
              resolve(data);
              commit()
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      UpdateProfile: ({commit}, payload) => {
        return new Promise((resolve, reject)=>{
          axios.put("/users",payload)
          .then(({data, status})=>{
            if(status === 200){
              resolve(data);
              commit()
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      ForgotPassword: ({commit}, payload) => {
        return new Promise((resolve, reject)=>{
          axios.post("/users/forgotpassword",payload)
          .then(({data, status})=>{
            if(status === 200){
              resolve(data);
              commit()
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      EditProfile: ({commit}, payload) => {
        return new Promise((resolve, reject)=>{
          axios.put("/users",payload)
          .then(({data, status})=>{
            if(status === 200){
              resolve(data);
              commit()
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      
      VerifyCode: ({commit}, payload) => {
        return new Promise((resolve, reject)=>{
          axios.post("/admin/userVerification",payload)
          .then(({data, status})=>{
            if(status === 200){
              resolve(data);
              commit()
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      ResendCode: ({commit}, payload) => {
        return new Promise((resolve, reject)=>{
          axios.post("/admin/userVerification/resendVerificationCode",payload)
          .then(({data, status})=>{
            if(status === 200){
              resolve(data);
              commit()
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
      GetImageUrl: ({commit}, payload )=>{
        var bodyFormData = new FormData();
        bodyFormData.append('file', payload.file);
        return new Promise ((resolve, reject)=>{
        axios({
          method: 'post',
          url: '/files',
          data: bodyFormData,
          config: { }
              })
              .then((data) => {
                resolve(data)
                commit()
              })
              .catch((error)=>{
                reject(error)
              });  
        });
      },
      AUTH_LOGOUT: ({commit})=>{
        return new Promise((resolve) => {
          localStorage.removeItem("token")
          window.localStorage.removeItem("vuex")  
          commit('Logout')        
          // remove the axios default header
          delete axios.defaults.headers.common['Authorization']
          if(localStorage.getItem("vuex")){
            resolve()
          }else{
            resolve()
           
          }
          
        })
      },
      // =================user management do new folder=============
      GetLoggedUser: ({commit}, payload) => {
        return new Promise((resolve, reject)=>{
          axios.get("/users/"+payload)
          .then(({data, status})=>{
            if(status === 200){
              commit('LoginDetails', data)
              resolve(data);
              
            }
          })
          .catch((error)=>{
            reject(error);
          });
        })
      },
    }
     
}